// NoticiaCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NoticiaCard.module.scss';

const NoticiaCard = ({ noticia }) => {
  return (
    <div className={styles.noticiaCardContainer}>
      <div className={styles.noticiaCardImageContainer}>
        {noticia.previsualizacion ? (
          <img
            src={noticia.previsualizacion}
            alt={noticia.titulo}
            className={styles.noticiaCardImage}
          />
        ) : (
          <div className={styles.noticiaCardPlaceholder}>No Image Available</div>
        )}
      </div>
      <h3 className={styles.noticiaCardTitle}>{noticia.titulo}</h3>
      <div className={styles.noticiaCardButtonWrapper}>
        <Link to={`/noticias/${noticia.slug}`} className={styles.noticiaCardButton}>
          IR A NOTICIA
        </Link>
      </div>
    </div>
  );
};

export default NoticiaCard;